import { defineStore } from 'pinia'
import { useRouter, useRoute } from 'vue-router'
import { computed, ref } from 'vue'
import { useNotificationStore } from '@/pinia/NotificationStore'
import { AxiosError } from 'axios'
import { showAxiosErrorDialog } from '@/util/dialogs.js'
import { tnApi } from '@/api'

export const useObuGlobalStore = defineStore('obu-global', () => {
  const { openFeratel } = tnApi()
  // const store = useObuGlobalStore()
  const router = useRouter()
  const route = useRoute()

  const loginRedirect = ref<string | null>(null)
  const failureSource = ref<string | null>(null)

  const source = computed(() => failureSource.value)

  const AauthorizedFailure = () => {
    router.push({ name: 'auth-logout' })
  }

  const showErrorDetails = (notification = null) => {
    console.log('showErrorDetails', notification)
    if (notification !== null) {
      showAxiosErrorDialog({
        errorObject: JSON.stringify(notification?.extraPayload)
      })
    }
  }

  const checkVies = async (vatId: string) => {
    const { checkVies } = tnApi()
    const result = await checkVies({ vatId })
    return result
  }

  const NetworkFailure = (error: AxiosError) => {
    const notificationStore = useNotificationStore()
    notificationStore.addClientNotification(
      {
        title: 'Netzwerkfehler',
        text: 'Wir konnten den Server nicht erreichen. Bitte versuche es später erneut.',
        variant: 'error',
        button: 'Details anzeigen',
        action: showErrorDetails,
        timeout: -1,
        extraPayload: error
      }
    )

    Promise.reject(error)
  }
  const SmtpFailure = () => {
    console.log('SmtpFailure')
    const notificationStore = useNotificationStore()
    notificationStore.addClientNotification(
      {
        title: 'SMTP-Fehler',
        text: 'Du kannst daher noch keine E-Mails (z. B. Antworten auf Anfragen) versenden.',
        variant: 'error',
        button: 'Zur SMTP-Konfiguration',
        route: { name: 'obu-settings-mails-stmp' },
        timeout: -1
      }, true, true
    )
  }

  const getFeratelCredentials = async () => {
    const result = await openFeratel()
    return result
  }

  const ForbiddenFailure = () => {
    failureSource.value = route.fullPath
    router.push({ name: 'forbidden' })
  }

  const NotFoundFailure = () => {
    failureSource.value = route.fullPath
    router.push({ name: 'not-found' })
  }

  const setLoginRedirect = (redirect: string) => {
    console.log(redirect)
    loginRedirect.value = redirect
  }

  const redirectAfterLogin = () => {
    console.log('***', loginRedirect.value)
    if (loginRedirect.value) {
      router.push({ path: loginRedirect.value })
    } else {
      router.push({ name: 'dashboard' })
    }
  }

  return { checkVies, AauthorizedFailure, getFeratelCredentials, ForbiddenFailure, NetworkFailure, NotFoundFailure, SmtpFailure, source, setLoginRedirect, redirectAfterLogin, loginRedirect }
})
